<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western" id="calibre_pb_0"><img alt="tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m360fc102.jpg" class="calibre1" id="Picture_9" src="tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m360fc102.jpg"/></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?4ade09e2